import { Stores } from "setupContext";

export class BaseStore {
    public rootStore: Stores;
}